import React from "react";

const Check: React.FC = () => {
  return (
    <svg
      width="11"
      height="8"
      viewBox="0 0 11 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.46967 3.46967C0.762563 3.17678 1.23744 3.17678 1.53033 3.46967L4 5.93934L9.46967 0.46967C9.76256 0.176776 10.2374 0.176777 10.5303 0.46967C10.8232 0.762563 10.8232 1.23744 10.5303 1.53033L4.53033 7.53033C4.38967 7.67098 4.19891 7.75 4 7.75C3.80108 7.75 3.61032 7.67098 3.46967 7.53033L0.46967 4.53033C0.176777 4.23744 0.176777 3.76256 0.46967 3.46967Z"
        fill="white"
      />
    </svg>
  );
};

export default Check;
